var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKebabMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "KebabMenu_svg__MuiSvgIcon-root KebabMenu_svg__MuiSvgIcon-fontSizeMedium KebabMenu_svg__css-1iirmgg",
    "aria-hidden": "true",
    viewBox: "0 0 24 24",
    "data-testid": "MoreVertIcon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
  })));
}
export default SvgKebabMenu;